<template>
  <div>
    <slot name='display' :open='showModal'>
      <a @click='showModal'>
        Buy Subscription
      </a>
    </slot>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    showModal () {
      this.$modal.show('details')
    }
  }
}
</script>

<style lang="scss" scoped>
  .progress {
    background-color: $atlas-blue;
    .indeterminate {
      background-color: $btn-color;
    }
  }

  .buymodal {
    flex-grow: 1;
    padding: 50px 14px;
    height: unset;

    .subscription-title {
      font-weight: bold;
      font-size: 2em;
      vertical-align: middle;
    }

    .subscription-subtitle {
      font-size: 1em;
      vertical-align: middle;
      padding-bottom: 30px;
    }

    .subscription-price {
      font-weight: bold;
      vertical-align: middle;

      .subscription-price-amount {
        font-size: 3em;
      }

      .subscription-price-sign {
        font-size: 2.5em;
        vertical-align: top;
      }

      .subscription-price-per {
        font-size: 1.5em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// BuyCredits.vue?482a5810